import React from 'react';
import { Avatar, Skeleton, Typography, Tag, Space } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { SalesProfile } from '../../../types/dashboard';

const { Title, Text } = Typography;

interface SalesDetailProfileCardProps {
  profile: SalesProfile | null;
  loading: boolean;
  glassCardStyle: React.CSSProperties;
}

const SalesDetailProfileCard: React.FC<SalesDetailProfileCardProps> = ({
  profile,
  loading,
  glassCardStyle
}) => {
  return (
    <div style={glassCardStyle} className="glass-card-interactive">
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <Skeleton.Avatar active size={80} shape="circle" style={{ marginBottom: '16px' }} />
          <Skeleton active paragraph={{ rows: 4 }} title={false} />
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '10px 0' }}>
          <Avatar
            size={84}
            icon={<UserOutlined />}
            src={profile?.avatar}
            style={{
              border: '3px solid #7BAA18',
              boxShadow: '0 4px 12px rgba(123, 170, 24, 0.25)',
              marginBottom: '16px'
            }}
          />
          <Title level={4} style={{ margin: '0 0 4px 0', color: '#0f172a', fontWeight: 800 }}>
            {profile?.user_name}
          </Title>
          <Tag color="green" style={{ fontSize: '11px', fontWeight: 'bold', padding: '2px 10px', borderRadius: '4px', marginBottom: '20px' }}>
            Sales Agent / Unit
          </Tag>

          <div style={{ textAlign: 'left', marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '14px', borderTop: '1px solid rgba(0,0,0,0.06)', paddingTop: '20px' }}>
            <Space align="start">
              <MailOutlined style={{ color: '#1890ff', marginTop: '4px' }} />
              <div>
                <Text type="secondary" style={{ fontSize: '11px', display: 'block' }}>Alamat Email</Text>
                <Text strong style={{ fontSize: '13px', color: '#1e293b' }}>{profile?.email}</Text>
              </div>
            </Space>
            <Space align="start">
              <PhoneOutlined style={{ color: '#52c41a', marginTop: '4px' }} />
              <div>
                <Text type="secondary" style={{ fontSize: '11px', display: 'block' }}>Nomor Telepon</Text>
                <Text strong style={{ fontSize: '13px', color: '#1e293b' }}>{profile?.phone || '-'}</Text>
              </div>
            </Space>
            <Space align="start">
              <EnvironmentOutlined style={{ color: '#f87171', marginTop: '4px' }} />
              <div>
                <Text type="secondary" style={{ fontSize: '11px', display: 'block' }}>Wilayah Kerja (PPU)</Text>
                <Space size={[0, 4]} wrap style={{ marginTop: '4px' }}>
                  {profile?.property_areas?.map(area => (
                    <Tag color="blue" key={area} style={{ margin: 0, fontSize: '11px' }}>{area}</Tag>
                  )) || <Text>-</Text>}
                </Space>
              </div>
            </Space>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalesDetailProfileCard;
